module.exports = __webpack_public_path__ + "img/icon-implantation-09.89488b3a.svg";